export interface Apis {
  videoPage: string;
  videoAdd: string;
  videoUpdate: string;
  videoDelete: string;
  videoDetail: string;
}
export const apis: Apis = {
  videoPage: '/iparkAdmin/video/selectVideoByPage',
  videoAdd: '/iparkAdmin/video/insertVideo',
  videoUpdate: '/iparkAdmin/video/updateVideo',
  videoDelete: '/iparkAdmin/video/deleteVideo',
  videoDetail: '/iparkAdmin/video/selectVideoByVideoId'
}
